import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportBidReportAsPdfMutation,
  ExportBidReportAsPdfMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const updateBidPublicity = graphql(`
  mutation exportBidReportAsPDF($input: ExportBidReportRequest!) {
    exportBidReportAsPDF(ExportBidReportRequest: $input) {
      id
      url
    }
  }
`);

export function useExportBidReportAsPDF(
  options?: UseMutationOptions<
    ExportBidReportAsPdfMutation,
    unknown,
    ExportBidReportAsPdfMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(updateBidPublicity, options);
}
